

import dayjs from 'dayjs'
import _ from 'lodash' // 픽업매장 선택 팝업
import { pdMixin } from '@/mixin/pd/pdMixin'
import orMixin from '~/mixin/or/orMixin'

import InfoContainer from '~/components/common/template/InfoContainer.vue'
import DeliveryAddress from '@/components/pd/common/address/DeliveryAddress.vue' // 주소지 영역
import ScrMbc011503 from '@/pages/mb/mbc/SCR_MBC_0115_03.vue' // 배송지변경 팝업
import ScrMbc011702 from '@/pages/mb/mbc/SCR_MBC_0117_02.vue' // 픽업매장 팝업
import CommonButton from '~/components/common/button/CommonButton.vue'
import CommonImage from '~/components/common/CommonImage.vue'
import Tooltip from '~/components/common/tooltip/Tooltip.vue'
import StepDialog from '~/components/common/bulk/StepDialog.vue'
import StepDialogHoliday from '~/components/common/holiday/StepDialogHoliday.vue'
import StepQuickDialog from '~/components/common/quick/StepQuickDialog.vue'
import DaisoDialog from '~/components/common/modal/DaisoDialog.vue'

export default {
  components: {
    StepQuickDialog,
    InfoContainer,
    CommonButton,
    CommonImage,
    DeliveryAddress,
    ScrMbc011503,
    ScrMbc011702,
    Tooltip,
    StepDialog,
    StepDialogHoliday,
    DaisoDialog
  },
  mixins: [pdMixin, orMixin],
  props: {
    pdUnit: { // 상품상세 정보
      type: Object,
      default: () => {
        return {}
      }
    },
    dlvcPlcy: { // 배송정책
      type: Object,
      default: () => {
        return {}
      }
    },
    isGoMass: { // 대량주문으로 가기
      type: Boolean,
      default: false
    },
    viewType: { // 화면 구성 타입 (gnr: 일반, bun: 세트상품, gf: 상품권)
      type: String,
      default: ''
    },
    isOpenRun: {
      type: Boolean, // 전략상품여부
      default: false
    }
  },
  data () {
    return {
      dlvParmType: '', // 택배 배송예정 타입
      dlvParmDay: '', // 택배 배송예정일
      dlvParmWeek: '', // 택배 배송요일
      dlvParmDtYn: 'N', // 택배 배송예정일 노출여부
      dlvParmDt: '', // 택배 배송예정일
      cutOffTime: '',
      reqShippingDtYn: 'N', // 택배 출발예정일 노출여부
      reqShippingDt: '', // 출발예정일
      purchaseValue: '01',
      dlvParmEdt: '', // 대량주문 배송예정일
      disStDlvDay: '', // 정기배송 배송예정일
      disStDlvWeek: '', // 정기배송 배송요일
      disStDlvParmDtYn: '', // 정기배송 배송예정일 노출여부
      disStHldyDlvFlagYn: '', // 정기배송 휴일도착 가능 여부
      pickupDay: '오늘', // 픽업가능 날짜
      pickupHours: 13, // 픽업가능 시간
      dvya: null, // 배송지
      pkupStr: {}, // 픽업매장
      posiStr: {},
      quickStr: {
        closTm: 0,
        todayDeliverYn: 'N',
        todayHoildayYn: 'N',
        tomorrowHoildayYn: 'N',
        strCd: '',
        strUnable: false,
        stckUnable: false,
        maxWeight: 0,
        availQty: 0,
        nextDay: ''
      }, // 오늘배송매장
      dlvParam: {
        mbMngNo: this.getMbMngNo(), // 회원관리번호
        orTyCd: '', // 주문유형코드
        disDlvParmYn: 'N', // 배송예정일노출여부
        dtStr: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS')
      },
      resData: [
        {
          name: '택배배송',
          info: '',
          txt: '도착예정',
          unable: false,
          id: 'pds',
          visible: true,
          val: '01',
          orTyCd: '01'
        },
        {
          name: '매장픽업',
          info: '',
          txt: '픽업가능',
          unable: false,
          id: 'pkup',
          visible: true,
          val: '02',
          orTyCd: ''
        },
        {
          name: '오늘배송',
          info: '오늘',
          txt: '도착예정',
          unable: false,
          id: 'quick',
          visible: true,
          val: '05',
          orTyCd: ''
        },
        {
          name: '대량주문',
          info: '7일 이내',
          txt: '도착예정',
          unable: false,
          id: 'mass',
          visible: true,
          val: '04',
          orTyCd: '02',
          selPoiStrYn: 'N' // 거점매장조회 여부

        },
        {
          name: '정기배송',
          info: '',
          txt: '도착예정',
          unable: false,
          id: 'fdrm',
          visible: true,
          val: '03',
          orTyCd: '03'
        }
      ],
      dlvUnable: false,
      quickUnable: false,
      pkupUnable: false,
      returnUrl: this.$route.fullPath, // 매장픽업 팝업 비로그인 시 리턴 url
      strInfo: {}, // 픽업매장정보
      tooltipTimer: null,
      visiblePerchaseTool: false,
      perchaseToolTxt: '에는 재고가 없습니다.',
      toolTxt: {
        pickup: '에는 재고가 없습니다.',
        pickup2: '픽업 매장을 변경해 보세요',
        mass: '구매 가능한 대량주문 지역을 확인해 보세요'
      },
      location: {
        flag: true
      },
      selectPkupStore: {},
      selectMassStore: {},
      stepBulkDialogVisible: false,
      stepQuickDialogVisible: false,
      stepDialogVisibleHd: false,
      quickInfoDialogVisible: false,
      hldyDlvFlagYn: 'N', // 휴일도착 가능 여부
      dlvParamList: [], // 배송도착예정날짜 파라미터 목록
      hdInfoDialogVisible: false, // 휴일배송 안내 팝업
    }
  },
  computed: {
    gfcardYn () {
      // 상품권 여부
      return this.pdUnit.pdTy === '03'
    },
    pdsYn () {
      // 택배배송 여부
      return !this.gfcardYn && this.pdUnit.pdsOrPsblYn === 'Y'
    },
    pdsInfo () {
      // 택배 배송 안내
      return this.pdsYn && this.dlvcPlcy.bassDlvAm > 0 && this.dlvcPlcy.stdrAm > 0
    },
    pdsAriv () {
      // 택배 도착예정 안내
      return this.pdsYn && this.isNotEmpty(this.dlvParmType)
    },
    massYn () {
      // 대량배송 여부
      return !this.gfcardYn && this.pdUnit.massOrPsblYn === 'Y'
    },
    fdrmYn () {
      // 정기배송 여부
      return !this.gfcardYn && this.pdUnit.fdrmOrPsblYn === 'Y'
    },
    pkupYn () {
      // 매장픽업 여부
      return !this.gfcardYn && this.pdUnit.pkupOrPsblYn === 'Y'
    },
    quickYn () {
      // 오늘배송 여부
      return !this.gfcardYn && this.pdUnit.quickOrPsblYn === 'Y'
    },
    aditDlvcYn () {
      // 추가배송비 여부
      return this.pdUnit.aditDlvcTgtYn === 'Y' && this.pdUnit.aditDlvcStdrQy > 0 && this.pdUnit.aditDlvcAm > 0
    },
    pkupStrNm () {
      return this.pkupStr.strNm
    },
  },
  watch: {
    async dvya () {
      console.log('watch dvya')
      await this.selPosiStr() // 대량주문거점매장조회
      // if (this.purchaseValue === '04') {
      // await this.selMassInfo()
      // }
      // await this.selPdsInfo()
      // await this.selFdrmInfo()
      // 배송도착예정일자 한번에 조회
      await this.selDlvDtAll()
      // 오늘배송 조회
      await this.selPosiQuickStrInfo()
    },
    isGoMass (val) {
      if (val) {
        this.purchaseValue = '04'
        this.$emit('isGoMass', false)
      }
    },
    async purchaseValue (item) {
      this.$emit('purchaseValue', item)
      // 위치정보 동의
      if (this.isLogin && this.location.flag && (item === '02' || item === '04')) { await this.selGeolocation(item) }
    },
    pkupStr (val) {
      if (this.isNotEmpty(val)) {
        this.selPickupDate(val.strCd)
        this.selStore(val.strCd, 'pickStore')
      }
    }
  },
  beforeMount () {
    const vm = this
    this.$EventBus.$on('eb-after-change-dvya', (data) => { // 배송지변경 후처리 이벤트 수신
      if (vm.spbkSeCd === data?.spbkSeCd) {
        this.selOfflStrStck(data.strCd)
        this.selStore(data.strCd, 'pickStore')
        this.$EventBus.$emit('chg-pkup-str', this.pkupStr) // 픽업매장 정보 보내기
      }
    })
    clearTimeout(this.tooltipTimer)
    if (!this.massYn) {
      const mass = this.find(this.resData, { id: 'mass' })
      mass.visible = false
      this.dlvUnable = true
      this.$emit('massDlvUnable', this.dlvUnable)
    }
    if (!this.fdrmYn) {
      const fdrm = this.find(this.resData, { id: 'fdrm' })
      fdrm.visible = false
    }
    if (!this.pkupYn) {
      const pkup = this.find(this.resData, { id: 'pkup' })
      pkup.visible = false
    }
    if (!this.quickYn) {
      const quick = this.find(this.resData, { id: 'quick' })
      quick.visible = false
    }
    if (!this.pdsYn) {
      const pds = this.find(this.resData, { id: 'pds' })
      pds.visible = false
    }

    this.resData = this.resData.filter(item => item.visible)

    if (!this.gfcardYn) {
      this.resData.forEach((resItem, idx) => {
        if (resItem.visible && resItem.orTyCd !== '') {
          const checkDlvParam = _.cloneDeep(this.dlvParam)
          checkDlvParam.orTyCd = resItem.orTyCd
          checkDlvParam.disDlvParmYn = 'Y'
          if (resItem.id === 'pds') { // 택배는 무조건넣음
            this.dlvParamList.push(checkDlvParam)
          } else if (this.viewType !== 'bun') { // 나머지는 세트상품아닐때만 넣음
            this.dlvParamList.push(checkDlvParam)
          }
        }
      })
      if (!this.isLogin) {
        this.selDlvDtAll() // 배송예상도착일자 모두 조회
        // 오늘배송 안내
        this.selPosiQuickStrInfo()
      }
    }
  },
  beforeDestroy () {
    this.$EventBus.$off('eb-after-change-dvya')
  },
  async mounted () {
    console.log('mounted')
    if (!this.gfcardYn) {
      // 택배배송 안내
      // await this.selPdsInfo()
      if (this.viewType !== 'bun') {
        // 대량주문배송 안내
        // await this.selMassInfo()
        // 정기배송 안내
        // await this.selFdrmInfo()
        // 오늘배송 안내
        // await this.selPosiQuickStrInfo()
        // 매장픽업 안내
        this.selPkupInfo()
        // this.resData = this.resData.filter(item => item.visible)
        this.purchaseValue = this.resData[0].val
      } else {
        this.purchaseValue = '01'
        // this.resData = this.resData.filter(item => item.id === 'pds')

        this.bunQyChk()
      }
      if (this.isLogin) {
        await this.selBassDvyaInfo() // 기본배송지 조회
        await this.selBassPkupStrInfo() // 기본픽업매장 조회
        // await this.selPosiStr() // 거점매장 조회
      }
      this.showTooltip()
    }
  },
  methods: {
    // 택배배송 안내
    async selPdsInfo () {
      const delResData = this.resData.find(item => item.id === 'pds')
      if (this.isOpenRun && delResData) {
        delResData.info = ''
        delResData.unable = true
        delResData.txt = '재입고 예정'
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.pdsYn || this.viewType === 'bun') {
          this.dlvParam.orTyCd = '01'
          this.dlvParam.disDlvParmYn = 'Y'
          await this.selDlvDt()
        } else if (delResData) {
          delResData.visible = false
        }
      }
    },
    // 대량주문배송 안내
    async selMassInfo () {
      if (this.massYn) {
        this.dlvParam.orTyCd = '02'
        this.dlvParam.disDlvParmYn = 'Y'
        await this.selDlvDt()
      } else {
        const delResData = this.resData.find(item => item.id === 'mass')
        if (delResData) {
          delResData.visible = false
          this.dlvUnable = true
          this.$emit('massDlvUnable', this.dlvUnable)
        }
      }
    },
    // 정기배송 안내
    async selFdrmInfo () {
      const delResData = this.resData.find(item => item.id === 'fdrm')
      if (this.isOpenRun && delResData) {
        delResData.info = ''
        delResData.unable = true
        delResData.txt = '재입고 예정'
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.fdrmYn) {
          this.dlvParam.orTyCd = '03'
          this.dlvParam.disDlvParmYn = 'Y'
          await this.selDlvDt()
        } else if (delResData) {
          delResData.visible = false
        }
      }
    },
    // 매장픽업 안내
    selPkupInfo () {
      if (this.pkupYn) {
        this.selPickupDate()
      } else {
        const delResData = this.resData.find(item => item.id === 'pkup')
        if (delResData) {
          delResData.visible = false
        }
      }
    },
    // 오늘배송 안내
    async selQuickInfo () {
      this.dlvParam.orTyCd = '04'
      this.dlvParam.disDlvParmYn = 'Y'
      await this.selDlvDt()
    },
    selDlvDtAll () {
      this.$AxiosBuilder
        .data({ dlvSoList: this.dlvParamList, mbMngNo: this.dlvParam.mbMngNo, dtStr: this.dlvParam.dtStr })
        .build()
        .post('/common/dla-api/selDlvParmDtAll')
        .then((res) => {
          if (res.data) {
            const resResult = res.data
            console.log('result', res.data)
            for (const [orTyCd, result] of Object.entries(resResult)) {
              if (orTyCd === '01') { // 택배배송
                this.dlvParmDtYn = result.dlvParmDtYn
                this.dlvParmType = result.dlvParmType
                this.$emit('dlvParmDt', result)
                this.reqShippingDtYn = result.reqShippingDtYn
                this.cutOffTime = result.cutOffTime
                this.hldyDlvFlagYn = result.hldyDlvFlagYn
                this.dlvParmDt = result.dlvParmDt
                if (this.isNotEmpty(result.dlvParmDt)) {
                  const week = ['일', '월', '화', '수', '목', '금', '토']
                  const month = new Date(result.dlvParmDt).getMonth() + 1
                  const date = new Date(result.dlvParmDt).getDate()
                  const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]

                  this.dlvParmWeek = dayOfWeek
                  this.dlvParmDt = month + '/' + date + '(' + dayOfWeek + ')'
                }

                const dlvDay = this.resData.find(item => item.id === 'pds')
                if (this.isOpenRun || (this.pdUnit.stckQy <= 0 && this.pdUnit.sleStsCd === '03' && this.pdUnit.pdsOrPsblYn === 'Y')) {
                  if (dlvDay) {
                    dlvDay.info = ''
                    dlvDay.unable = true
                    dlvDay.txt = '재입고 예정'
                  }
                } else if (this.isNotEmpty(result.dlvParmDt)) {
                  if (result.dlvParmDtYn !== 'N') {
                    const week = ['일', '월', '화', '수', '목', '금', '토']
                    const month = new Date(result.dlvParmDt).getMonth() + 1
                    const date = new Date(result.dlvParmDt).getDate()
                    const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]
                    this.dlvParmDay = month + '/' + date + '(' + dayOfWeek + ')'
                    if (dlvDay) {
                      dlvDay.info = this.dlvParmDay // 택배배송 도착 예정 일자
                      this.$emit('dlvParmDay', this.dlvParmDay)
                    }
                  }
                }
              } else if (orTyCd === '02') { // 대량주문
                if (this.pdUnit.sleStsCd === '01') {
                  const massData = this.resData.find(item => item.id === 'mass') // 대량주문
                  this.dlvUnable = true
                  massData.unable = this.dlvUnable
                  massData.info = ''
                  massData.txt = '재입고 예정'
                } else {
                  const dlvParmEdt = dayjs(result.dlvParmEdt).format('YYYY-MM-DD')
                  if (this.isNotEmpty(dlvParmEdt)) {
                    const week = ['일', '월', '화', '수', '목', '금', '토']
                    const month = new Date(dlvParmEdt).getMonth() + 1
                    const date = new Date(dlvParmEdt).getDate()
                    const dayOfWeek = week[new Date(dlvParmEdt).getDay()]
                    this.dlvParmEdt = month + '/' + date + '(' + dayOfWeek + ')'
                    const dlvDay = this.resData.find(item => item.id === 'mass')
                    if (dlvDay && dlvDay.selPoiStrYn === 'Y' && !dlvDay.unable) {
                      dlvDay.info = '7일 이내' // 대량주문 도착 예정 일자
                      // this.$emit('massDlvParmDay', '7일 이내') 보내고 000c3에서 안씀
                    }
                  }
                }
              } else if (orTyCd === '03') { // 정기배송
                this.disStDlvParmDtYn = result.dlvParmDtYn
                this.disStHldyDlvFlagYn = result.hldyDlvFlagYn
                if (this.isOpenRun || (this.pdUnit.stckQy <= 0 && this.pdUnit.sleStsCd === '03' && this.pdUnit.pdsOrPsblYn === 'Y')) {
                  const dlvDay = this.resData.find(item => item.id === 'fdrm')
                  if (dlvDay) {
                    dlvDay.info = ''
                    dlvDay.unable = true
                    dlvDay.txt = '재입고 예정'
                  }
                } else if (this.isNotEmpty(result.dlvParmDt)) {
                  const week = ['일', '월', '화', '수', '목', '금', '토']
                  const month = new Date(result.dlvParmDt).getMonth() + 1
                  const date = new Date(result.dlvParmDt).getDate()
                  const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]

                  this.disStDlvWeek = dayOfWeek
                  this.disStDlvDay = month + '/' + date + '(' + dayOfWeek + ')'
                  const dlvDay = this.resData.find(item => item.id === 'fdrm')
                  if (dlvDay) {
                    dlvDay.info = this.disStDlvDay // 정기배송 도착 예정 일자
                    this.$emit('regDlvParmDay', this.disStDlvDay)
                  }
                }
              } else if (orTyCd === '04') { // 오늘배송
                this.quickStr.closTm = result.closTm
                this.quickStr.todayDeliverYn = result.todayDeliverYn
                this.quickStr.todayHoildayYn = result.todayHoildayYn
                this.quickStr.tomorrowHoildayYn = result.tomorrowHoildayYn
                this.quickStr.maxWeight = result.maxWeight
                const quickData = this.resData.find(item => item.id === 'quick') // 오늘배송
                if (quickData) {
                  const week = ['일', '월', '화', '수', '목', '금', '토']
                  const nextDay = new Date(this.dateYYYYMMDDFormatterStr(result.nextDay))
                  const month = nextDay.getMonth() + 1
                  const date = nextDay.getDate()
                  const dayOfWeek = week[new Date(nextDay).getDay()]
                  this.quickStr.nextDay = month + '/' + date + '(' + dayOfWeek + ')'
                  if (this.quickStr.todayHoildayYn === 'Y' || (this.quickStr.tomorrowHoildayYn === 'Y' && this.quickStr.todayDeliverYn === 'N')) {
                    quickData.info = ''
                    quickData.unable = true
                    quickData.txt = '재입고 예정'
                    this.$emit('quickDlvUnable', true)
                  } else {
                    quickData.unable = false
                    quickData.txt = '도착예정'
                    if (this.quickStr.todayDeliverYn === 'Y') {
                      quickData.info = '오늘'
                    } else {
                      const week = ['일', '월', '화', '수', '목', '금', '토']
                      const now = new Date()
                      const tomorrow = new Date(now.setDate(now.getDate() + 1))
                      const month = tomorrow.getMonth() + 1
                      const date = tomorrow.getDate()
                      const dayOfWeek = week[new Date(tomorrow).getDay()]
                      quickData.info = month + '/' + date + '(' + dayOfWeek + ')'
                    }
                  }
                }
              }
            }
          }
        }).catch((e) => {
          console.error('scr_pdl_000c2 selDlvDt error :', e)
        })
    },
    // 배송 예정일 조회
    async selDlvDt () {
      await this.$AxiosBuilder
        .data(this.dlvParam)
        .build()
        .post('/common/dla-api/selDlvParmDt')
        .then((res) => {
          if (res.data.success) {
            const result = res.data.data

            if (this.dlvParam.orTyCd === '01') { // 일반배송
              this.dlvParmType = result.dlvParmType
              this.reqShippingDtYn = result.reqShippingDtYn
              this.dlvParmDtYn = result.dlvParmDtYn
              this.cutOffTime = result.cutOffTime
              this.hldyDlvFlagYn = result.hldyDlvFlagYn
              this.dlvParmDt = result.dlvParmDt
              if (this.isNotEmpty(result.dlvParmDt)) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const month = new Date(result.dlvParmDt).getMonth() + 1
                const date = new Date(result.dlvParmDt).getDate()
                const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]
                this.dlvParmWeek = dayOfWeek

                this.dlvParmDt = month + '/' + date + '(' + dayOfWeek + ')'
              }

              const dlvDay = this.resData.find(item => item.id === 'pds')
              if (this.isOpenRun || (this.pdUnit.stckQy <= 0 && this.pdUnit.sleStsCd === '03' && this.pdUnit.pdsOrPsblYn === 'Y')) {
                if (dlvDay) {
                  dlvDay.info = ''
                  dlvDay.unable = true
                  dlvDay.txt = '재입고 예정'
                }
              } else if (this.isNotEmpty(result.dlvParmDt)) {
                if (result.dlvParmDtYn !== 'N') {
                  const week = ['일', '월', '화', '수', '목', '금', '토']
                  const month = new Date(result.dlvParmDt).getMonth() + 1
                  const date = new Date(result.dlvParmDt).getDate()
                  const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]
                  this.dlvParmDay = month + '/' + date + '(' + dayOfWeek + ')'
                  if (dlvDay) {
                    dlvDay.info = this.dlvParmDay
                    this.$emit('dlvParmDay', this.dlvParmDay)
                  }
                } else {
                  // eslint-disable-next-line no-lonely-if
                  if (dlvDay) {
                    dlvDay.info = ''
                    dlvDay.txt = ''
                  }
                }
              }
            } else if (this.dlvParam.orTyCd === '02') { // 대량배송
              const dlvParmEdt = dayjs(result.dlvParmEdt).format('YYYY-MM-DD')

              if (this.isNotEmpty(dlvParmEdt)) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const month = new Date(dlvParmEdt).getMonth() + 1
                const date = new Date(dlvParmEdt).getDate()
                const dayOfWeek = week[new Date(dlvParmEdt).getDay()]

                this.dlvParmEdt = month + '/' + date + '(' + dayOfWeek + ')'
                const dlvDay = this.resData.find(item => item.id === 'mass')
                if (dlvDay) {
                  // dlvDay.info = this.dlvParmEdt
                  // this.$emit('massDlvParmDay', this.dlvParmEdt)
                  dlvDay.info = '7일 이내'
                  this.$emit('massDlvParmDay', '7일 이내')
                }
              }
            } else if (this.dlvParam.orTyCd === '03') { // 정기배송
              this.disStDlvParmDtYn = result.dlvParmDtYn
              this.disStHldyDlvFlagYn = result.hldyDlvFlagYn
              if (this.pdUnit.stckQy <= 0 && this.pdUnit.sleStsCd === '03' && this.pdUnit.pdsOrPsblYn === 'Y') {
                const dlvDay = this.resData.find(item => item.id === 'fdrm')
                if (dlvDay) {
                  dlvDay.info = ''
                  dlvDay.unable = true
                  dlvDay.txt = '재입고 예정'
                }
              } else if (this.isNotEmpty(result.dlvParmDt)) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const month = new Date(result.dlvParmDt).getMonth() + 1
                const date = new Date(result.dlvParmDt).getDate()
                const dayOfWeek = week[new Date(result.dlvParmDt).getDay()]

                this.disStDlvWeek = dayOfWeek
                this.disStDlvDay = month + '/' + date + '(' + dayOfWeek + ')'
                const dlvDay = this.resData.find(item => item.id === 'fdrm')
                if (dlvDay) {
                  dlvDay.info = this.disStDlvDay
                  this.$emit('regDlvParmDay', this.disStDlvDay)
                }
              }
            } else if (this.dlvParam.orTyCd === '04') { // 오늘배송
              this.quickStr.closTm = result.closTm
              this.quickStr.todayDeliverYn = result.todayDeliverYn
              this.quickStr.todayHoildayYn = result.todayHoildayYn
              this.quickStr.tomorrowHoildayYn = result.tomorrowHoildayYn
              this.quickStr.maxWeight = result.maxWeight
              const quickData = this.resData.find(item => item.id === 'quick') // 오늘배송
              if (quickData) {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const nextDay = new Date(this.dateYYYYMMDDFormatterStr(result.nextDay))
                const month = nextDay.getMonth() + 1
                const date = nextDay.getDate()
                const dayOfWeek = week[new Date(nextDay).getDay()]
                this.quickStr.nextDay = month + '/' + date + '(' + dayOfWeek + ')'
                if (this.quickStr.todayHoildayYn === 'Y' || (this.quickStr.tomorrowHoildayYn === 'Y' && this.quickStr.todayDeliverYn === 'N')) {
                  quickData.info = ''
                  quickData.unable = true
                  quickData.txt = '재입고 예정'
                  this.$emit('quickDlvUnable', true)
                } else {
                  quickData.unable = false
                  quickData.txt = '도착예정'
                  if (this.quickStr.todayDeliverYn === 'Y') {
                    quickData.info = '오늘'
                  } else {
                    const week = ['일', '월', '화', '수', '목', '금', '토']
                    const now = new Date()
                    const tomorrow = new Date(now.setDate(now.getDate() + 1))
                    const month = tomorrow.getMonth() + 1
                    const date = tomorrow.getDate()
                    const dayOfWeek = week[new Date(tomorrow).getDay()]
                    quickData.info = month + '/' + date + '(' + dayOfWeek + ')'
                  }
                }
              }
            }
          }
        }).catch((e) => {
          console.error('scr_pdl_000c2 selDlvDt error :', e)
        })
    },
    async selPickupDate (strCd) {
      const params = { strCd }
      await this.$AxiosBuilder
        .params(params)
        .build()
        .get('/dl/dla-api/selStrInfo')
        .then((res) => {
          if (res.data.success) {
            const strInfo = res.data.data
            this.strInfo = strInfo
            const currentTime = dayjs().format('YYYY-MM-DD')
            const tmr = dayjs(currentTime).add(1, 'day').format('YYYY-MM-DD') // 내일날짜
            const nowHours = new Date().getHours()
            const week = ['일', '월', '화', '수', '목', '금', '토']
            if ((currentTime === this.strInfo.strHldyDt) || (tmr === this.strInfo.strHldyDt)) { // 오늘 날짜가 매장휴일 이거나 내일날짜가 매장휴일인경우 매장휴일 다음날 픽업가능
              const possiPkupDt = dayjs(this.strInfo.strHldyDt).add(1, 'day').format('YYYY-MM-DD')
              this.pickupDay = new Date(possiPkupDt).getMonth() + 1 + '/' + new Date(possiPkupDt).getDate() + '(' + week[new Date(possiPkupDt).getDay()] + ')'
            } else if (nowHours < 17) { // 오늘 시간 17시간전 오늘 가능
              this.pickupDay = '오늘'
              // this.pickupDay = new Date(currentTime).getMonth() + 1 + '/' + new Date(currentTime).getDate() + '(' + week[new Date(currentTime).getDay()] + ')'
            } else { // 오늘 시간 17시 이후면 내일 가능
              this.pickupDay = new Date(tmr).getMonth() + 1 + '/' + new Date(tmr).getDate() + '(' + week[new Date(tmr).getDay()] + ')'
            }
            if (!this.pkupUnable) {
              const dlvDay = this.resData.find(item => item.id === 'pkup')
              if (dlvDay) {
                dlvDay.info = this.pickupDay
                this.$EventBus.$emit('pkup-dlv-day', this.pickupDay)
              }
            }
          }
        }).catch((e) => {
          console.log('selStrInfo error :', e)
        })
    },
    // 기본배송지 조회
    async selBassDvyaInfo () {
      const dvya = await this.selBassDvya()
      this.$EventBus.$emit('eb-change-dvya', dvya)
      this.dvya = dvya
    },
    // 기본픽업매장 조회
    async selBassPkupStrInfo () {
      const pkupStr = await this.selBassPkupStr() // 기본픽업매장 조회
      this.pkupStr = pkupStr
      this.$EventBus.$emit('chg-pkup-str', pkupStr) // 픽업매장 정보 보내기
      if (this.viewType !== 'bun') {
        await this.selOfflStrStck() // 픽업매장 재고 조회
      }
    },
    // 거점매장 조회
    async selPosiStr () {
      if (this.massYn && this.isNotEmpty(this.dvya) && this.viewType !== 'bun') { // 기본 배송지가 등록되어 있으면 조회
        const posiStr = await this.selPosiStrInfo(this.dvya.addrZip)
        this.posiStr = posiStr
        const delResData = this.resData.find(item => item.id === 'mass') // 대량주문
        if (!posiStr?.strLgctCntrCd) { // 거점매장 부재시
          this.dlvUnable = true
          if (delResData) {
            delResData.unable = true
            delResData.info = ''
            delResData.txt = '이용 불가'
            delResData.selPoiStrYn = 'Y'
          }
        } else {
          this.dlvUnable = false
          if (delResData) {
            delResData.unable = false
            delResData.info = '7일 이내'
            delResData.txt = '도착예정'
            delResData.selPoiStrYn = 'Y'
          }

          await this.selStore(posiStr.strCd, 'massStore')
          // 대량주문 재고조회 임시 주석
          // try {
          //   const strCd = posiStr.strLgctCntrCd // 매장코드
          //   const pdNo = this.pdUnit.pdNo // 상품번호
          //   await this.selOfflCntrStck(strCd, pdNo) // 재고수량 조회
          // } catch (e) {
          //   console.error('scr_pdl_000c2 selOfflCntrStck error :', e)
          // }
        }

        this.$emit('massDlvUnable', this.dlvUnable)
      }
    },
    async selPosiQuickStrInfo () {
      const quickData = this.resData.find(item => item.id === 'quick') // 오늘배송
      if (this.quickYn) {
        await this.selQuickInfo()
        if (this.isNotEmpty(this.dvya)) {
          const posiStr = await this.selectPosiQuickStrInfo(this.dvya.addrZip, false)
          if (!posiStr) { // 거점매장 부재시
            this.quickUnable = true
            this.quickStr.strUnable = true
            this.quickStr.strCd = ''
            quickData.unable = true
            quickData.info = ''
            quickData.txt = '이용 불가'
            this.quickStr.availQty = 1
            this.$emit('quickDlvUnable', this.quickUnable)
          } else if (this.quickStr.todayHoildayYn === 'N' && (this.quickStr.todayDeliverYn === 'Y' || this.quickStr.tomorrowHoildayYn === 'N')) {
            this.quickUnable = false
            quickData.unable = false
            this.quickStr.strUnable = false
            this.quickStr.strCd = posiStr.strCd
            this.quickStr.availQty = posiStr.availQty
            await this.selQuickOfflStrStck()
          } else {
            this.quickUnable = false
            this.quickStr.strUnable = false
            this.$emit('quickDlvUnable', true)
          }
        } else {
          this.quickStr.availQty = 1
          this.quickUnable = false
          if (this.isLogin) {
            this.$emit('quickDlvUnable', true)
          } else {
            this.$emit('quickDlvUnable', false)
          }
        }
      } else if (this.isNotEmpty(quickData)) {
        quickData.visible = false
      }
    },
    // 대량배송 재고수량 조회
    // async selOfflCntrStck (strCd, pdNo) {
    //   const massUnable = this.resData.find(item => item.id === 'mass')
    //   const params = [{ strCd, pdNo }]
    //   await this.$AxiosBuilder
    //     .data(params)
    //     .build()
    //     .post('/pdo/selOfflCntrStck')
    //     .then((res) => {
    //       if (res.data.success) {
    //         const result = res.data.data

    //         if (result[0].stck <= 0) {
    //           this.dlvUnable = true
    //           massUnable.unable = true
    //           massUnable.info = ''
    //           massUnable.txt = '재입고 예정'

    //           this.$emit('massOfflCntrStck', [{ stck: 0 }])
    //           this.$emit('massDlvUnable', this.dlvUnable)
    //         } else {
    //           this.dlvUnable = false
    //           massUnable.unable = false
    //           // massUnable.info = this.dlvParmEdt
    //           massUnable.info = '7일 이내'
    //           massUnable.txt = '도착예정'

    //           this.$emit('massOfflCntrStck', result)
    //           this.$emit('massDlvUnable', this.dlvUnable)
    //         }
    //       } else {
    //         this.dlvUnable = true
    //         massUnable.unable = true
    //         massUnable.info = ''
    //         massUnable.txt = '재입고 예정'

    //         this.$emit('massOfflCntrStck', [{ stck: 0 }])
    //         this.$emit('massDlvUnable', this.dlvUnable)
    //       }
    //     }).catch((e) => {
    //       console.error('scr_pdl_000c2 selOfflCntrStck error :', e)
    //     })
    // },
    // 픽업매장 재고 조회
    async selOfflStrStck (value) {
      if (this.pkupYn && this.isNotEmpty(this.pkupStr)) {
        let param = []
        if (value) {
          param = [{ pdNo: this.pdUnit.pdNo, strCd: value }] // 재고조회 검색조건 파라미터, 기본 매장이 아닌 경우
        } else {
          param = [{ pdNo: this.pdUnit.pdNo, strCd: this.pkupStr.strCd }] // 재고조회 검색조건 파라미터, 기본 매장인 경우
        }

        try {
          const selOfflStrStck = await this.post('/pd/pdh/selStrPkupStck', param) // 재고조회(픽업매장)
          const pkupUnable = this.resData.find(item => item.id === 'pkup')

          if (this.isNotEmpty(selOfflStrStck) && selOfflStrStck.length > 0) {
            if (this.pdUnit.grpPdYn === 'Y' && this.pdUnit.pdTy === '05') {
              let totalStck = 0
              for (const grpStck of selOfflStrStck) {
                totalStck += Number(grpStck.stck)
              }
              const totalStckObj = _.cloneDeep(selOfflStrStck[0])
              totalStckObj.stck = totalStck
              totalStckObj.pdNo = this.pdUnit.pdNo

              const pkupOfflStrStck = { ...totalStckObj, grpOfflStrStckList: selOfflStrStck }

              if (totalStckObj.stck <= 0) {
                this.pkupUnable = true
                pkupUnable.unable = this.pkupUnable
                pkupUnable.info = ''
                pkupUnable.txt = '재입고 예정'
                this.$emit('selOfflStrStck', [{ stck: 0 }])
              } else {
                this.pkupUnable = false
                pkupUnable.unable = this.pkupUnable
                pkupUnable.info = this.pickupDay
                pkupUnable.txt = '픽업가능'
                this.$emit('selOfflStrStck', pkupOfflStrStck)
              }
            } else if (selOfflStrStck[0].stck <= 0) {
              this.pkupUnable = true
              pkupUnable.unable = this.pkupUnable
              pkupUnable.info = ''
              pkupUnable.txt = '재입고 예정'
              this.$emit('selOfflStrStck', [{ stck: 0 }])
            } else {
              this.pkupUnable = false
              pkupUnable.unable = this.pkupUnable
              pkupUnable.info = this.pickupDay
              pkupUnable.txt = '픽업가능'
              this.$emit('selOfflStrStck', selOfflStrStck)
            }
          } else {
            this.pkupUnable = true
            pkupUnable.unable = this.pkupUnable
            pkupUnable.info = ''
            pkupUnable.txt = '재입고 예정'
            this.$emit('selOfflStrStck', [{ stck: 0 }])
          }
        } catch (e) {
          console.log('selOfflStrStck Error ::: ', e)
        }

        this.$emit('pkupDlvUnable', this.pkupUnable)
      }
    },
    async selQuickOfflStrStck () {
      if (this.quickYn && this.isNotEmpty(this.quickStr.strCd)) {
        const params = [{ pdNo: this.pdUnit.pdNo, strCd: this.quickStr.strCd, cmmnCd: '03' }] // 재고조회 검색조건 파라미터
        const selQuickOfflStrStck = await this.post('/pd/pdh/selStrPkupStck', params)
        const quickUnable = this.resData.find(item => item.id === 'quick')
        if (this.isNotEmpty(selQuickOfflStrStck) && selQuickOfflStrStck.length > 0) {
          if (this.pdUnit.grpPdYn === 'Y' && this.pdUnit.pdTy === '05') {
            let totalStck = 0
            for (const grpStck of selQuickOfflStrStck) {
              totalStck += Number(grpStck.stck)
            }
            const totalStckObj = _.cloneDeep(selQuickOfflStrStck[0])
            totalStckObj.stck = totalStck
            totalStckObj.pdNo = this.pdUnit.pdNo

            const quickOfflStrStck = { ...totalStckObj, grpOfflStrStckList: selQuickOfflStrStck }

            if (totalStckObj.stck <= 0) {
              this.quickUnable = true
              quickUnable.unable = this.quickUnable
              quickUnable.info = ''
              quickUnable.txt = '재입고 예정'
              this.$emit('selQuickOfflStrStck', [{ stck: 0 }])
            } else {
              this.$emit('selQuickOfflStrStck', quickOfflStrStck)
            }
          }
          if (this.pdUnit.pdTy !== '05') {
            if (selQuickOfflStrStck[0].stck <= 0 || this.pdUnit.quickMaxOrPsblQy <= 0 || this.quickStr.availQty <= 0) {
              quickUnable.unable = true
              quickUnable.info = ''
              quickUnable.txt = '재입고 예정'
              this.$emit('quickDlvUnable', true)
              this.$emit('selQuickOfflStrStck', [{ stck: 0 }])
            } else {
              quickUnable.unable = false
              quickUnable.txt = '도착예정'
              if (this.quickStr.todayDeliverYn === 'Y') {
                quickUnable.info = '오늘'
              } else {
                const week = ['일', '월', '화', '수', '목', '금', '토']
                const now = new Date()
                const tomorrow = new Date(now.setDate(now.getDate() + 1))
                const month = tomorrow.getMonth() + 1
                const date = tomorrow.getDate()
                const dayOfWeek = week[new Date(tomorrow).getDay()]
                quickUnable.info = month + '/' + date + '(' + dayOfWeek + ')'
              }
              this.$emit('quickDlvUnable', false)
              this.$emit('selQuickOfflStrStck', selQuickOfflStrStck)
            }
          }
        } else {
          quickUnable.unable = true
          quickUnable.info = ''
          quickUnable.txt = '재입고 예정'
          this.$emit('quickDlvUnable', true)
          this.$emit('selQuickOfflStrStck', [{ stck: 0 }])
        }
      }
    },
    openLayer () {
      this.openDvyaChgPpup()
    },
    openPickupLayer () {
      this.$refs.pickPpup.outerVisible = true
    },
    throwEbChangeDvya (data) { // [MO] 배송지 선택 변경
      this.$EventBus.$emit('eb-change-dvya', data)
      this.dvya = data
    },
    bunQyChk () {
      if (this.pdUnit.bunMaxOrQy <= 0) {
        const delResData = this.resData.find(item => item.id === 'pds')
        delResData.unable = true
        delResData.info = ''
        delResData.txt = '재입고 예정'
      }
    },
    showTooltip () {
      if (this.pkupUnable) {
        this.perchaseToolTxt = this.pkupStrNm + this.toolTxt.pickup
      } else {
        this.perchaseToolTxt = this.toolTxt.mass
      }
      this.tooltipTimer = setTimeout(() => {
        this.visiblePerchaseTool = true
        this.hideTooltip()
      }, 200)
    },
    hideTooltip () {
      if (this.pkupUnable) {
        this.tooltipTimer = setTimeout(() => {
          this.perchaseToolTxt = this.toolTxt.pickup2
          this.tooltipTimer = setTimeout(() => {
            this.visiblePerchaseTool = false
          }, 2000)
        }, 2000)
      } else {
        this.tooltipTimer = setTimeout(() => {
          this.visiblePerchaseTool = false
        }, 3000)
      }
    },
    async selStore (strCd, type) {
      // 조회
      const selStoreForm = {
        inclusiveStrCd: strCd,
        keyword: '',
        curLitd: this.location.longitude,
        curLttd: this.location.latitude
      }
      const storeInfo = await this.$AxiosBuilder
        .data(selStoreForm)
        .build()
        .post('/ms/msg/selStr')
        .then((res) => {
          return res.data.data[0]
        })
        .catch((e) => {
          console.debug(e)
        })
      if (type === 'pickStore') {
        this.selectPkupStore = storeInfo
        this.$set(this.pkupStr, 'km', storeInfo.km)
      } else if (type === 'massStore') {
        this.selectMassStore = storeInfo
      }
    },
    selGeolocation (type) {
      this.$AxiosBuilder
        .data({
          mbMngNo: this.$store.getters['session/getMbMngNo'],
          mbEid: this.$store.getters['session/getMbEid'],
          lcInfoGetSeCd: this.checkMobile()
        })
        .build()
        .post('/ms/msg/selGeolocationAgrYn')
        .then((res) => {
          if (res.data.data) {
            if (res.data.data.geolocationAgrYn === 'Y') {
              navigator.geolocation.getCurrentPosition((position) => {
                this.location.latitude = position.coords.latitude
                this.location.longitude = position.coords.longitude
                this.location.geolocationAgrYn = 'Y'
                this.location.flag = true
                if (type === '02' && this.isNotEmpty(this.pkupStr)) {
                  this.selStore(this.pkupStr.strCd, 'pickStore')
                } else if (type === '04' && this.isNotEmpty(this.posiStr)) {
                  this.selStore(this.posiStr.strCd, 'massStore')
                }
              }, (error) => {
                console.log(error)
              })
            } else {
              this.location.flag = false
              if (type === '02' && this.isNotEmpty(this.pkupStr)) {
                this.selStore(this.pkupStr.strCd, 'pickStore')
              } else if (type === '04' && this.isNotEmpty(this.posiStr)) {
                this.selStore(this.posiStr.strCd, 'massStore')
              }
            }
          }
        })
    },
    openBulkPop () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      this.stepBulkDialogVisible = true
    },
    closeBulkPopup (type) {
      this.stepBulkDialogVisible = false
      if (type === 'list') {
        this.openLayer()
      }
    },
    openQuickPop () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      this.stepQuickDialogVisible = true
    },
    closeQuickPopup (type) {
      this.stepQuickDialogVisible = false
      if (type === 'list') {
        this.openLayer()
      }
    },
    openPopHd () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      this.stepDialogVisibleHd = true
    },
    closePopupHd (type) {
      this.stepDialogVisibleHd = false
      if (type === 'list') {
        this.openLayer()
      }
    },
    closeDvyaChgPpup (form) {
      if (form && form.bassDvyaYn === 'Y') {
        this.selBassDvyaInfo()
      }
    }
  }
}
